export enum StorageKeys {
  LOCALE_KEY = 'LOCALE_KEY',
  USER_DATA_KEY = 'USER_DATA_KEY',
  TOKEN_KEY = 'TOKEN_KEY',
  USER = 'currentUser',
  LANGUAGE = 'lang'
}
